/**
 * Whether an async-model call actually succeeded.
 *
 * `run()` resolves `undefined` when the request fails, so `resp?.isSuccessful === false` is never
 * true and every guard written that way is dead code. Some endpoints also return void on success,
 * where `undefined` is the correct result - so the model's own error flag is the only reliable
 * signal, not the shape of what came back.
 */
export const succeeded = (asyncModel, resp) => !(asyncModel !== null && asyncModel !== void 0 && asyncModel.isError) && (resp === null || resp === void 0 ? void 0 : resp.isSuccessful) !== false;